<!-- Title & Buttons Header Section -->

<div class="card mb-1 ml-0" *ngIf=" config$ | async as config  ">
    <div class="title-section-header d-flex justify-content-between align-items-center flex-wrap">
        <div class="items">
            <div ngbDropdown class="d-inline-block station-dropdown">
                <a class="station-trigger" id="stationDropdown" ngbDropdownToggle >
                    <img [src]="getStationLogo(currentStation)" class="logo-img" alt="logo" *ngIf="currentStation?.logo">
                    <div class="station-avatar" *ngIf="!currentStation?.logo">
                        {{ getStationInitials(currentStation) }}
                    </div>
                    <h4 class="mb-0 size16"><strong>{{ (currentStation?.nom_entreprise || currentStation?.label) | enterpriseName }}</strong></h4>

                </a>
                <div ngbDropdownMenu aria-labelledby="stationDropdown" class="station-dropdown-menu">
                    <div class="station-dropdown-header">Entreprises</div>

                    <a ngbDropdownItem 
                       *ngFor="let station of allStations" 
                       (click)="switchStation(station)"
                       class="station-item"
                       [class.active]="station.id === currentStation?.id">
                        <div class="station-item-content">
                            <div class="station-item-avatar" *ngIf="!station.logo">
                                {{ getStationInitials(station) }}
                            </div>
                            <img *ngIf="station.logo" [src]="getStationLogo(station)" class="station-item-logo" alt="logo">
                            <div class="station-item-info">
                                <div class="station-item-name">{{ station.label }}</div>
                                <div class="station-item-subtitle">Info</div>
                            </div>
                            <span class="station-status-dot" *ngIf="station.id === currentStation?.id"></span>
                        </div>
                    </a>
                </div>
            </div>
        </div>

        <div class=" align-items-center icons">
            <div ngbDropdown
                 class="d-inline-block notification-bell-wrap"
                 container="body"
                 display="dynamic"
                 dropdownClass="app-notification-dropdown-root"
                 placement="bottom-right bottom-left top-right">
                <button type="button" class="unstyled-btn position-relative notification-bell-btn" id="appNotifDropdown" ngbDropdownToggle aria-label="Notifications">
                    <i class="bi bi-bell notification-bell-icon"></i>
                    <ng-container *ngIf="unreadCount$ | async as uc">
                        <span class="notification-badge" *ngIf="uc > 0">{{ uc > 99 ? '99+' : uc }}</span>
                    </ng-container>
                </button>
                <div ngbDropdownMenu aria-labelledby="appNotifDropdown" class="app-notification-menu">
                    <div class="app-notification-panel">
                        <div class="app-notification-header">
                            <div class="app-notification-header-inner">
                                <div class="app-notification-title-block">
                                    <span class="app-notification-title-icon" aria-hidden="true">
                                        <i class="bi bi-bell-fill"></i>
                                    </span>
                                    <div>
                                        <h6 class="app-notification-title">Notifications</h6>
                                        <p class="app-notification-subtitle">Votre activité récente</p>
                                    </div>
                                </div>
                                <div class="app-notification-actions">
                                    <button type="button"
                                            class="app-notification-action-btn"
                                            title="Tout marquer comme lu"
                                            (click)="markAllNotificationsRead(); $event.stopPropagation()">
                                        <i class="bi bi-check2-all" aria-hidden="true"></i>
                                        <span>Tout lu</span>
                                    </button>
                                    <button type="button"
                                            class="app-notification-action-btn app-notification-action-btn--danger"
                                            title="Effacer toutes les notifications"
                                            (click)="clearAllNotifications($event)">
                                        <i class="bi bi-trash3" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="app-notification-list">
                            <ng-container *ngIf="notifications$ | async as list">
                                <div *ngIf="list.length === 0" class="app-notification-empty">
                                    <span class="app-notification-empty-icon" aria-hidden="true">
                                        <i class="bi bi-inbox"></i>
                                    </span>
                                    <p class="app-notification-empty-title">Aucune notification</p>
                                    <p class="app-notification-empty-hint">Les alertes et messages apparaîtront ici.</p>
                                </div>
                                <div *ngFor="let n of list"
                                     class="dropdown-item app-notification-item"
                                     [class.app-notification-unread]="!n.read"
                                     (click)="onNotificationClick(n)">
                                    <div class="app-notification-item-icon"
                                         [ngClass]="getNotificationIconVariant(n.type)"
                                         aria-hidden="true">
                                        <i [ngClass]="getNotificationIconClass(n.type)"></i>
                                    </div>
                                    <div class="app-notification-item-body min-width-0">
                                        <div class="app-notification-item-top">
                                            <span class="app-notification-item-title text-break">{{ n.title }}</span>
                                            <span class="app-notification-item-time">{{ n.createdAt | date:'short' }}</span>
                                        </div>
                                        <p class="app-notification-item-text text-break">{{ n.body }}</p>
                                    </div>
                                    <button type="button"
                                            class="app-notification-remove"
                                            (click)="removeNotification(n.id, $event)"
                                            aria-label="Supprimer">
                                        <i class="bi bi-x-lg"></i>
                                    </button>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>

            <button
                type="button"
                class="unstyled-btn modules-hub-nav-btn d-inline-block"
                title="Modules"
                aria-label="Modules"
                (click)="openModulesHub()">
                <i class="bi bi-grid-3x3-gap modules-hub-nav-icon" aria-hidden="true"></i>
            </button>

            <button
                *ngIf="showLogicielCaisseShortcut()"
                type="button"
                class="unstyled-btn logiciel-caisse-nav-btn d-inline-block"
                title="Ouvrir le logiciel caisse"
                aria-label="Ouvrir le logiciel caisse"
                (click)="openLogicielCaisseFront()">
                <i class="bi bi-cash-stack logiciel-caisse-nav-icon" aria-hidden="true"></i>
            </button>

            <button
                type="button"
                class="unstyled-btn parametre-db-nav-btn d-inline-block parametre-db-dropdown"
                title="Paramètres des données"
                aria-label="Paramètres des données"
                (click)="openParametreDonnees()">
                <i class="bi bi-database parametre-db-icon" aria-hidden="true"></i>
            </button>

            <i class="bi bi-translate"  ></i>

                <li class="nav-item d-lg-block">
                    <div ngbDropdown class="theme-dropdown">
                        <a type="button" class="nav-link nav-link-style btn theme-trigger" id="themeDropdown" ngbDropdownToggle>
                            <span [ngClass]="getThemeIcon()" class="ficon font-medium-5 feather"></span>
                        </a>
                        <div ngbDropdownMenu aria-labelledby="themeDropdown" class="theme-dropdown-menu">
                            <a ngbDropdownItem 
                               (click)="setTheme('light')" 
                               class="theme-option"
                               [class.active]="currentTheme === 'light'">
                                <span data-feather="sun" [size]="18" class="theme-icon"></span>
                                <span class="theme-label">Light</span>
                            </a>
                            <a ngbDropdownItem 
                               (click)="setTheme('dark')" 
                               class="theme-option"
                               [class.active]="currentTheme === 'dark'">
                                <span data-feather="moon" [size]="18" class="theme-icon"></span>
                                <span class="theme-label">Dark</span>
                            </a>
                            <a ngbDropdownItem 
                               (click)="setTheme('system')" 
                               class="theme-option"
                               [class.active]="currentTheme === 'system'">
                                <span data-feather="monitor" [size]="18" class="theme-icon"></span>
                                <span class="theme-label">System</span>
                            </a>
                        </div>
                    </div>
                </li>
            <div ngbDropdown class="d-inline-block">
                <button class="unstyled-btn" id="quickAddDropdown" ngbDropdownToggle aria-expanded="false">
                    <i data-feather="plus-circle" [size]="20" class=""></i>
                </button>
                <div ngbDropdownMenu aria-labelledby="quickAddDropdown" class="dropdown-menu-end quick-add-dropdown">
                    <div class="quick-add-header">Ajout rapide</div>
                    <div class="quick-add-grid">
                        <!-- Devis -->
                        <a ngbDropdownItem class="quick-add-item" (click)="navigateToDevis()">
                            <div class="quick-add-compartment">
                                <div class="quick-add-icon-wrapper">
                                    <span data-feather="dollar-sign" [size]="24" class="quick-add-icon"></span>
                                </div>
                                <div class="quick-add-content">
                                    <div class="quick-add-title">Devis</div>
                                    <div class="quick-add-subtitle">Ajouter un nouveau devis</div>
                                </div>
                            </div>
                        </a>
                        <!-- Facture -->
                        <a ngbDropdownItem class="quick-add-item" (click)="navigateToFacture()">
                            <div class="quick-add-compartment">
                                <div class="quick-add-icon-wrapper">
                                    <span data-feather="file-text" [size]="24" class="quick-add-icon"></span>
                                </div>
                                <div class="quick-add-content">
                                    <div class="quick-add-title">Facture</div>
                                    <div class="quick-add-subtitle">Ajouter une nouvelle facture</div>
                                </div>
                            </div>
                        </a>
                        <!-- Fournisseur -->
                        <a ngbDropdownItem class="quick-add-item" (click)="navigateToFournisseur()">
                            <div class="quick-add-compartment">
                                <div class="quick-add-icon-wrapper">
                                    <span data-feather="user" [size]="24" class="quick-add-icon"></span>
                                </div>
                                <div class="quick-add-content">
                                    <div class="quick-add-title">Fournisseur</div>
                                    <div class="quick-add-subtitle">Ajouter un nouveau fournisseur</div>
                                </div>
                            </div>
                        </a>
                        <!-- Client -->
                        <a ngbDropdownItem class="quick-add-item" (click)="navigateToClient()">
                            <div class="quick-add-compartment">
                                <div class="quick-add-icon-wrapper">
                                    <span data-feather="users" [size]="24" class="quick-add-icon"></span>
                                </div>
                                <div class="quick-add-content">
                                    <div class="quick-add-title">Client</div>
                                    <div class="quick-add-subtitle">Ajouter un nouveau client</div>
                                </div>
                            </div>
                        </a>
                        <!-- Produit -->
                        <a ngbDropdownItem class="quick-add-item" (click)="navigateToProduit()">
                            <div class="quick-add-compartment">
                                <div class="quick-add-icon-wrapper">
                                    <span data-feather="shopping-cart" [size]="24" class="quick-add-icon"></span>
                                </div>
                                <div class="quick-add-content">
                                    <div class="quick-add-title">Produit</div>
                                    <div class="quick-add-subtitle">Ajouter un nouveau produit</div>
                                </div>
                            </div>
                        </a>
                        <!-- Entreprise -->
                        <a ngbDropdownItem class="quick-add-item" (click)="navigateToEntreprise()">
                            <div class="quick-add-compartment">
                                <div class="quick-add-icon-wrapper">
                                    <i class="bi bi-buildings quick-add-icon" style="font-size: 24px;"></i>
                                </div>
                                <div class="quick-add-content">
                                    <div class="quick-add-title">Entreprise</div>
                                    <div class="quick-add-subtitle">Ajouter une nouvelle entreprise</div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>


            <div ngbDropdown class="settings-dropdown">
                <button class="unstyled-btn" id="settingsDropdown" ngbDropdownToggle>
                    <i data-feather="settings" [size]="20"></i>
                </button>
                <div ngbDropdownMenu aria-labelledby="settingsDropdown" class="settings-dropdown-menu">
                    <a ngbDropdownItem
                       href="javascript:void(0)"
                       class="settings-option"
                       (click)="openParametre('/main/parametre/entreprise')">
                        <i class="bi bi-buildings  size"></i>
                        <span class="settings-label">Profil de l'entreprise</span>
                    </a>
                    <a ngbDropdownItem
                       href="javascript:void(0)"
                       class="settings-option"
                       (click)="openParametre('/main/parametre/document')">
                        <span data-feather="file-text" [size]="18" class="settings-icon"></span>
                        <span class="settings-label">Paramètres des documents</span>
                    </a>
                    <a ngbDropdownItem
                       href="javascript:void(0)"
                       class="settings-option"
                       (click)="openParametre('/main/parametre/compte-bancaire')">
                        <i class="bi bi-bank settings-icon" style="font-size: 18px;"></i>
                        <span class="settings-label">Compte bancaire</span>
                    </a>
                    <a ngbDropdownItem
                       href="javascript:void(0)"
                       class="settings-option"
                       (click)="openParametre('/main/parametre/taxe-tva')">
                        <span data-feather="percent" [size]="18" class="settings-icon"></span>
                        <span class="settings-label">Taxes et TVA</span>
                    </a>
                    <a ngbDropdownItem
                       href="javascript:void(0)"
                       class="settings-option"
                       (click)="openParametre('/main/parametre/liste-prix')">
                        <span data-feather="file-text" [size]="18" class="settings-icon"></span>
                        <span class="settings-label">Liste de prix</span>
                    </a>
                    <a ngbDropdownItem
                       href="javascript:void(0)"
                       class="settings-option"
                       (click)="openParametre('/main/parametre/comptable-parametre')">
                        <span data-feather="briefcase" [size]="18" class="settings-icon"></span>
                        <span class="settings-label">Comptable</span>
                    </a>
                    <a ngbDropdownItem
                       href="javascript:void(0)"
                       class="settings-option"
                       (click)="openParametre('/main/parametre/user-and-role')">
                        <span data-feather="users" [size]="18" class="settings-icon"></span>
                        <span class="settings-label">Utilisateurs et rôles</span>
                    </a>
                    <a ngbDropdownItem
                       href="javascript:void(0)"
                       class="settings-option"
                       (click)="openParametre('/main/parametre/integration')">
                        <span data-feather="link" [size]="18" class="settings-icon"></span>
                        <span class="settings-label">Intégration</span>
                    </a>
                    <a ngbDropdownItem
                       href="javascript:void(0)"
                       class="settings-option"
                       (click)="openParametre('/main/parametre/projets')">
                        <span data-feather="folder" [size]="18" class="settings-icon"></span>
                        <span class="settings-label">Projets</span>
                    </a>
                    <a ngbDropdownItem
                       href="javascript:void(0)"
                       class="settings-option"
                       (click)="openParametre('/main/parametre/marque-categorie/categories')">
                        <span data-feather="tag" [size]="18" class="settings-icon"></span>
                        <span class="settings-label">Marques, catégories et unités</span>
                    </a>
                </div>
            </div>

            <ul class="nav navbar-nav align-items-center ml-auto mr-1 ">
                <!-- ? Language selection | Uncomment if needed-->
                <!-- <li ngbDropdown class="nav-item dropdown dropdown-language">
                  <a class="nav-link dropdown-toggle" id="dropdown-flag" ngbDropdownToggle>
                    <i class="flag-icon flag-icon-{{ languageOptions[_translateService.currentLang].flag }}"></i
                    ><span class="selected-language">{{ languageOptions[_translateService.currentLang].title }}</span></a
                  >
                  <div ngbDropdownMenu aria-labelledby="dropdown-flag">
                    <a *ngFor="let lang of _translateService.getLangs()" ngbDropdownItem (click)="setLanguage(lang)">
                      <i class="flag-icon flag-icon-{{ languageOptions[lang].flag }}"></i> {{ languageOptions[lang].title }}
                    </a>
                  </div>
                </li> -->
                <!--/ Language selection -->

                <!-- User Dropdown-->
                <li ngbDropdown class="nav-item dropdown-user">
                    <a
                            class="nav-link dropdown-toggle dropdown-user-link"
                            id="navbarUserDropdown"
                            ngbDropdownToggle
                            aria-haspopup="true"
                            aria-expanded="false">
                        <span class="avatar">
                                <div class="user-avatar-nav" aria-hidden="true">{{ getEntrepriseFirstLetter() }}</div>
                            </span>
                    </a>
                    <div ngbDropdownMenu
                            aria-labelledby="navbarUserDropdown"
                            class="dropdown-menu dropdown-menu-right user-dropdown-menu">
                        <!-- User Info Section -->
                        <div class="user-dropdown-header">
                            <div class="user-avatar-large">
                                <div class="user-avatar-icon">{{ getEntrepriseFirstLetter() }}</div>
                            </div>
                            <div class="user-info">
                                <div class="user-name">{{ getCoordonneeDisplayName() }}</div>
                                <div class="user-email">{{ currentUser?.email || 'email@example.com' }}</div>
                                <a href="#" class="user-link">{{ getStationIdentifier() }}</a>
                            </div>
                        </div>

                        <div class="dropdown-divider"></div>

                        <!-- Navigation Links Section -->
                        <div class="user-dropdown-nav">
                            <a ngbDropdownItem [routerLink]="['/profile']" class="user-nav-item">
                                <span data-feather="user" [size]="18" class="user-nav-icon"></span>
                                <span class="user-nav-label">Mon profil</span>
                            </a>

                            <a ngbDropdownItem [routerLink]="['/abonnements']" class="user-nav-item">
                                <span data-feather="calendar" [size]="18" class="user-nav-icon"></span>
                                <span class="user-nav-label">Abonnements</span>
                            </a>

                            <a ngbDropdownItem [routerLink]="['/tickets']" class="user-nav-item">
                                <span data-feather="bookmark" [size]="18" class="user-nav-icon"></span>
                                <span class="user-nav-label">Mes tickets</span>
                                <span class="user-nav-badge">4</span>
                            </a>
                        </div>

                        <div class="dropdown-divider"></div>

                        <!-- Settings Section -->
                        <div class="user-dropdown-settings">
                            <a ngbDropdownItem [routerLink]="['/parametres/compte']" class="user-nav-item">
                                <span data-feather="settings" [size]="18" class="user-nav-icon"></span>
                                <span class="user-nav-label">Paramètres du compte</span>
                            </a>

                            <div class="dropdown-item user-nav-item user-toggle-item">
                                <span data-feather="monitor" [size]="18" class="user-nav-icon"></span>
                                <span class="user-nav-label">Barre sombre</span>
                                <label class="toggle-switch">
                                    <input type="checkbox" [checked]="currentSkin === 'dark'" (change)="toggleDarkMode($event)">
                                    <span class="toggle-slider"></span>
                                </label>
                            </div>
                        </div>

                        <!-- Logout Button -->
                        <a ngbDropdownItem (click)="logout()" class="user-logout-btn">
                            <span class="user-logout-text">Se Déconnecter</span>
                            <i data-feather="log-out" [size]="18" class="user-logout-icon"></i>
                        </a>
                    </div>

                </li>
                <!--/ User Dropdown -->
            </ul>

        </div>
    </div>
    <div class="card-body d-flex justify-content-between align-items-center " style="height: 54px;">
        <div class=" size15"><strong>{{ config.title }}</strong></div>
        <div class="buttons align-items-center">
            <ng-container *ngFor="let button of config.buttons">
                <!-- Bouton standard -->
                <button
                        *ngIf="button.type !== 'dropdown'"
                        class="btn"
                        [ngClass]="{
            'btn-primary': button.type === 'primary',
            'btn-dark': button.type === 'dark',
            'btn-outline-primary': button.type === 'secondary'
          }"
                        [disabled]="button.disabled"
                        (click)="button.action()"
                >
                    {{ button.label }}
                </button>
                <!-- Bouton dropdown -->
                <div *ngIf="button.type === 'dropdown'" ngbDropdown class="ml-1 mr-1" >
                    <button
                            class="btn btn-outline-primary"
                            id="exportDropdown_{{ button.label }}"
                            ngbDropdownToggle
                    >
                        {{ button.label }}
                    </button>
                    <div ngbDropdownMenu [attr.aria-labelledby]="'exportDropdown_' + button.label" class="dropdown-menu-end">
                        <button
                                *ngFor="let item of button.dropdownItems"
                                ngbDropdownItem
                                (click)="item.action()"
                                class="d-flex align-items-center"
                        >
                            <img *ngIf="item.icon" [src]="item.icon" [alt]="item.label" style="width: 24px; height: auto;">
                            <p style="font-size: 15px; color: rgba(47, 43, 61, 0.9); font-weight: 500; margin-left: 8px; margin-top: 12px; margin-bottom: 0;">
                                {{ item.label }}
                            </p>
                        </button>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
